'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.submitLiveBid = exports.getLiveBidItemId = exports.getLiveBidAmount = exports.getUiLiveBid = exports.LIVE_BID_SUCCESS = exports.LIVE_BID_REQUEST = exports.LIVE_BID_FAIL = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _modal = require('../modules/modal');

var _api = require('../api');

var _reselect = require('reselect');

var _user = require('../modules/user');

var _config = require('../modules/config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LIVE_BID_FAIL = exports.LIVE_BID_FAIL = 'la/ui/liveBid/FAIL';
var LIVE_BID_REQUEST = exports.LIVE_BID_REQUEST = 'la/ui/liveBid/REQUEST';
var LIVE_BID_SUCCESS = exports.LIVE_BID_SUCCESS = 'la/ui/liveBid/SUCCESS';

// reducer
var DEFAULT_STATE = {
    bidAmount: null,
    bidPlaced: false,
    itemId: null,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _modal.DISMISS_LIVE_BID_MODAL:
            return (0, _extends3.default)({}, state, {
                bidPlaced: false
            });
        case _modal.OPEN_LIVE_BID_MODAL:
            return (0, _extends3.default)({}, state, {
                bidAmount: action.payload.bidAmount,
                itemId: action.payload.itemId
            });
        case LIVE_BID_REQUEST:
            return (0, _extends3.default)({}, state, {
                bidPlaced: true,
                submitted: true,
                success: false
            });
        case LIVE_BID_SUCCESS:
            return (0, _extends3.default)({}, state, {
                bidAmount: null,
                isCurrentHighBid: action.payload.isCurrentHighBid,
                submitted: false,
                success: true
            });
        case LIVE_BID_FAIL:
            return (0, _extends3.default)({}, state, {
                error: true,
                submitted: false,
                success: false
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.liveBid;
};

var getUiLiveBid = exports.getUiLiveBid = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

var getLiveBidAmount = exports.getLiveBidAmount = (0, _reselect.createSelector)(getUiLiveBid, function (uiState) {
    return !isNaN(uiState.bidAmount) ? uiState.bidAmount : null;
});

var getLiveBidItemId = exports.getLiveBidItemId = (0, _reselect.createSelector)(getUiLiveBid, function (uiState) {
    return uiState.itemId ? uiState.itemId : null;
});

/* ACTIONS CREATORS */
var submitLiveBid = exports.submitLiveBid = function submitLiveBid(_ref) {
    var bidAmount = _ref.bidAmount,
        catalogId = _ref.catalogId,
        itemId = _ref.itemId;
    return function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: { bidAmount: bidAmount, catalogId: catalogId, itemId: itemId },
                                type: LIVE_BID_REQUEST
                            });
                            _context.next = 7;
                            return _api.Bid.postPlaceLiveBid({ authToken: authToken, bidAmount: bidAmount, deployment: deployment, itemId: itemId });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: {
                                    actionTime: Date.now(),
                                    itemId: itemId
                                },
                                payload: response,
                                type: LIVE_BID_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                payload: _context.t0,
                                type: LIVE_BID_FAIL
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
        };
    }();
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/liveBid.js
// module id = xmqD
// module chunks = 46